export interface EnvironmentVariableMetaData {
  type: string
}

export interface SentryEnvironmentVariables {
  /**
   * Data source name for the sentry project
   */
  dsn: string,

  /**
   * Percentage of transactions captured for performance monitoring. 1.0 being 100%.
   */
  tracesSampleRate: number

  /**
   * A collection of domains or patterns where if they match the current domain, it will enable tracing
   */
  tracePropagationTargets: Array<string | RegExp>
}

export interface EnvironmentVariables {
  production: boolean
  tokenLocalStorageKey: string
  routeTracing: boolean
  workflowHost: string
  preventInitialLoad: boolean
  validator: string
  defaultService: string
  saveLocation: string
  serviceId: number

  /**
   * The version of the project as defined in the root package.json
   */
  version?: string

  /**
   * Number of milliseconds before the session expires that a warning will be displayed
   */
  durationBeforeSessionExpiringWarning: number

  /**
   * Environment variables for configuring Sentry monitoring
   */
  sentry?: SentryEnvironmentVariables

  /**
   * The URL where the application and all of it's compiled .js files will be served from
   */
  deployUrl: string

  /**
   * A flag that will force the registered custom elements to adopt the stylesheets of the host document
   */
  customElementAdoptStyleSheets: boolean
}

/**
 * MetaData for the environment variables.
 *
 * This is useful when trying to convert attributes or other sources
 * of configurations into environment variables for the application.
 */
export const environmentMeta: { [key in keyof EnvironmentVariables]: EnvironmentVariableMetaData } = {
  production: { type: 'boolean' },
  tokenLocalStorageKey: { type: 'string' },
  routeTracing: { type: 'boolean' },
  workflowHost: { type: 'string' },
  preventInitialLoad: { type: 'boolean' },
  validator: { type: 'string' },
  defaultService: { type: 'string' },
  saveLocation: { type: 'string' },
  serviceId: { type: 'number' },
  version: { type: 'string' },
  durationBeforeSessionExpiringWarning: { type: 'string' },
  sentry: { type: 'object' },
  deployUrl: { type: 'string' },
  customElementAdoptStyleSheets: { type: 'boolean' }
}
